import { render } from "./VotesGeneratorPage.vue?vue&type=template&id=3f0354e2&ts=true"
import script from "./VotesGeneratorPage.vue?vue&type=script&lang=ts"
export * from "./VotesGeneratorPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__